<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ title }}</h3>
        <button class="modal-close" @click="close">Close</button>
      </div>
      <div class="modal-body doc">
        <h2>PMLA (ANTI MONEY LAUNDERING) POLICY</h2>

        <h3>Introduction</h3>
        <p>This policy is framed and adopted as a requirement by SEBI under the Prevention of Money Laundering Act, 2002 (“PMLA”).The policy provides a framework with respect to anti money laundering measures to be taken by VIVEK GUPTA, as a SEBI registered Investment Adviser.</p>

        <h3>I. Objective of the PMLA Policy</h3>
        <p>The objective of the PMLA policy is as follows:</p>
        <ol>
          <li>To prevent VIVEK GUPTA from being used, intentionally or unintentionally, by criminal Create a elements for money laundering or terrorist financing activities.</li>
          <li>Awareness and provide clarity on KYC standards and AML measures.</li>
          <li>To have a proper Client Due Diligence (CDD) process before registering clients.</li>
          <li>To monitor and report suspicious transactions.</li>
          <li>To monitor / maintain records of all cash transactions done by the client of the value of more than Rs. 10 lacs.</li>
        </ol>

        <h3>II. Client Due Diligence (CDD) Process</h3>
        <p>As a part of Client Due Diligence process, VIVEK GUPTA will do the following:</p>
        <ol>
          <li>Maintain a record of Know Your Customer (KYC) documents (i.e valid identity proof and address proof) obtained from the entire client at the time of on boarding the clients.</li>
          <li>In order to verify the genuineness of the clients, to speak with the clients before proceeding with any research services.</li>
          <li>The records between the client and VIVEK GUPTA to be maintained in proper order.</li>
        </ol>

        <h3>III. Policy for Acceptance of Client</h3>
        <p>VIVEK GUPTA will ensure that-</p>
        <ol type="a">
          <li>No account shall be opened in fictitious name or on an anonymous basis.</li>
          <li>No account will be opened if the fee for services is offered by the client in cash.</li>
          <li>No account is opened where VIVEK GUPTA is unable to apply appropriate CDD measures/ KYC policies. This shall apply to cases where the information provided to VIVEK GUPTA is suspected to be non - genuine, or there is perceived non - cooperation of the client in providing full and complete information.</li>
          <li>It will be ensured that the identity of the client does not match with any person having known criminal background or is not banned in any other manner or is included in the list of individuals and entities which are subject to various sanction measures such as freezing of assets/accounts, denial of financial services etc., as approved by the Security Council Committee established pursuant to various United Nations' Security Council Resolutions (UNSCRs) can be accessed at its website at <a href="http://www.un.org/sc/committees/1267/consolist.shtml" target="_blank" rel="noopener noreferrer">http://www.un.org/sc/committees/1267/consolist.shtml</a>.</li>
          <li>Each client shall be classified in low or medium or high risk categories depending upon the risk perception. Such risk may be arrived considering various factors of risk perception of the client having regard to:-
            <ul>
              <li>clients’ location (registered office address, correspondence addresses and other addresses if applicable),</li>
              <li>nature of business activity, trading turnover etc. and</li>
              <li>manner of making payment for transactions undertaken.</li>
            </ul>
          </li>
          <li>Clients of Special Category (CSC) require higher degree of due diligence and regular update of Know Your Client (KYC) profile.
            <p>Clients of Special Category (CSC) shall include:</p>
            <ol type="i">
              <li>Non - resident clients;</li>
              <li>High net-worth clients;</li>
              <li>Trust, Charities, Non-Governmental Organizations (NGOs) and organizations receiving donations;</li>
              <li>Companies having close family shareholdings or beneficial ownership;</li>
              <li>Politically Exposed Persons (PEP);</li>
              <li>Companies offering foreign exchange offerings;</li>
              <li>Clients in high risk countries where existence / effectiveness of money laundering controls is suspect;</li>
              <li>Non face to face clients;</li>
              <li>Clients with dubious reputation as per public information available etc.</li>
            </ol>
          </li>
        </ol>

        <h3>IV. Suspicious Transactions</h3>
        <ol>
          <li>VIVEK GUPTA will ensure that that appropriate steps are taken to enable suspicious transactions to be recognized based on the circumstances like-
            <ol type="a">
              <li>Clients whose identity verification is difficult or client is not ready to cooperate.</li>
              <li>Where the source of funds of the clients is not clear or not keeping with clients apparent standing/ business activity;</li>
              <li>Substantial increases in business without apparent cause;</li>
              <li>Clients based in high risk jurisdictions;</li>
              <li>Clients transferring large sums of money to or from overseas locations with instructions for payment in cash;</li>
              <li>Attempted transfer of investment proceeds to apparently unrelated third parties;</li>
              <li>Unusual transactions by CSCs and businesses undertaken by offshore banks/financial services, businesses reported to be in the nature of export- import of small items.</li>
            </ol>
          </li>
          <li>In the event of any suspicious transaction, VIVEK GUPTA will make a report based on the reference to the clients, transactions and the nature/ reason of suspicion. The report will be submitted to the Director, Financial Intelligence Unit-India.</li>
          <li>In the event where the transactions are abandoned or aborted by clients on being asked to give some details or to provide documents, VIVEK GUPTA will report all such attempted transactions in Suspicious Transaction Reports, even if not completed by clients, irrespective of the amount of the transaction.</li>
        </ol>

        <h3>V. Monitoring of transactions</h3>
        <p>The transactions shall be monitored in the following manner:</p>
        <ol type="a">
          <li>Special attention shall be paid to all complex unusually large transactions / patterns which appear to have no economic purpose.</li>
          <li>Internal threshold limits for each class of client accounts shall be defined and special attention shall be paid to transactions which exceeds these limits.</li>
          <li>The background including all documents/office records /memorandums/clarifications sought pertaining to such transactions and purpose thereof shall also be examined carefully and findings shall be recorded in writing.</li>
          <li>Further the findings, records and related documents shall be made available to auditors and also to SEBI/stock exchanges/FIUIND/ other relevant Authorities, during audit, inspection or as and when required.</li>
          <li>These records shall be preserved for a period of five years from the date of transaction with such client.</li>
          <li>The following transactions shall be monitored at all times:
            <ol type="i">
              <li>all cash transactions of the value of more than ten lakh rupees or its equivalent in foreign currency;</li>
              <li>all series of cash transactions integrally connected to each other which have been individually valued below rupees ten lakh or its equivalent in foreign currency where such series of transactions have taken place within a month and the monthly aggregate exceeds an amount of ten lakh rupees or its equivalent in foreign currency;</li>
              <li>all cash transactions where forged or counterfeit currency notes or bank notes have been used as genuine or where any forgery of a valuable security or a document has taken place facilitating the transactions;</li>
              <li>all suspicious transactions whether or not made in cash and by way of cheques, pay orders, travellers cheques, demand drafts, loan and advances, money transfer or remittances in favour of own clients or non-clients from India or abroad and to third party beneficiaries in India or abroad, credits or debits into or from any non-monetary accounts such as d-mat account.</li>
            </ol>
          </li>
          <li>Periodic review of the existing account shall be conducted to ensure that no existing accounts are linked to any of the entity or individual included in the list by Security Council Committee. Any resemblance found to be reported to SEBI and FIU-IND.</li>
        </ol>

        <h3>VI. Record Keeping and Retention of Records</h3>
        <ol>
          <li>In case of suspicious transactions, VIVEK GUPTA will -
            <ol type="a">
              <li>ensure compliance with the record keeping requirements contained in the SEBI (Investment Adviser) Regulations, 2014, PMLA and other relevant legislation.</li>
              <li>maintain such records as are sufficient to permit trail of individual transactions (including the amount and types of currencies involved, if any) so as to provide, if necessary, evidence for prosecution of any criminal behaviour.</li>
              <li>retain the following information for the accounts of the clients in order to maintain a satisfactory audit trail so that in case of any suspected drug related or other laundered money or terrorist property, the competent investigating authorities can trace through the audit trail for reconstructing a financial profile of the suspected account:
                <ol type="i">
                  <li>the beneficial owner of the account; and</li>
                  <li>for selected transactions, the origin of funds, the form in which the funds were offered or withdrawn, e.g. cheques, demand drafts etc, the identity of the person undertaking the transaction, the destination of the funds and, the form of instruction and authority.</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>Record of the transactions shall be preserved and those transactions of a suspicious nature shall be reported to the Director, FIU-IND.</li>
          <li>Record of information related to transactions, whether attempted or executed, which are reported to the Director, FIU‐IND and shall be maintained and preserved for a period of five years from the date of the transaction with the client. In situations where the records relate to on-going investigations or transactions which have been the subject of a suspicious transaction reporting, they shall be retained until it is confirmed that the case has been closed.</li>
        </ol>

        <h3>VII. Information to be maintained</h3>
        <p>Following information in respect of all transactions referred to Clause V.f of this policy shall be maintained:</p>
        <ol type="a">
          <li>the nature of the transactions;</li>
          <li>the amount of the transaction and the currency in which it is denominated;</li>
          <li>the date on which the transaction was conducted; and</li>
          <li>the parties to the transaction.</li>
        </ol>

        <h3>VIII. Reporting to Financial Intelligence Unit-India</h3>
        <p>In terms of the PML Rules, VIVEK GUPTA will report information relating to cash and suspicious transactions to the Director, Financial Intelligence Unit-India (FIU-IND) at the following address:</p>
        <p>
          Director,<br />
          FIU-IND, Financial Intelligence Unit-India,<br />
          6th Floor, Hotel Samrat, Chanakyapuri, New Delhi - 110021.<br />
          Website: <a href="http://fiuindia.gov.in" target="_blank" rel="noopener noreferrer">http://fiuindia.gov.in</a>
        </p>

        <h3>IX. Appointment of Principal Officer and Designated Director:</h3>
        <p>To ensure effective discharge of our legal obligations, to report suspicious transactions to the authorities and overall supervision and compliance, the following shall be the “Principal Officer” and “Designated Director” who would act as a central reference point for the identification and assessment of potentially suspicious transactions and in facilitating onward reporting of suspicious transactions to FIU:</p>
        <ol type="i">
          <li>
            Name: VIVEK GUPTA<br />
            Designation: Investment Adviser<br />
            Email Id: vivek203@yahoo.com<br />
            Phone Number: 9958836060
          </li>
        </ol>

        <h3>X. Rights, Obligation and Responsibilities of Principal Officer:</h3>
        <ol type="a">
          <li>The principal office shall have all time access to customer identification data and other CDD information.</li>
          <li>The principal officer shall have complete independence and authority to access.</li>
          <li>The principal officer shall ensure that the PMLA Policy framework is implemented effectively.</li>
          <li>The principal officer shall ensure data generated on FIU on suspicious transaction is regularly and promptly downloaded to analyze, identify and report transactions of suspicious nature to FIU-IND directly.</li>
          <li>The principal officer shall ensure that the records and information in relation to all client and transaction are available on timely basis to the competent authority.</li>
          <li>The principal officer shall ensure that there is a prompt response to any request for information, including KYC related information and records maintained by VIVEK GUPTA, made by the regulators, FIU-IND and other statutory authorities.</li>
          <li>The principal officer shall ensure all concerned staff is regularly updated regarding any changes / additions / modifications in PMLA provisions.</li>
        </ol>

        <h3>XI. Rights, Obligations and Responsibilities of Designated Director:</h3>
        <ol type="a">
          <li>The Designated Director should ensure that all the records are maintained as mentioned in this Policy.</li>
          <li>In case where the Designated Director fails to perform his duties, he shall be penalised and appropriate action may be taken against him.</li>
        </ol>

        <h3>XII. Employees’ Hiring/ Employee’s Training/ Investor Education:</h3>
        <p>VIVEK GUPTA will-</p>
        <ol type="a">
          <li>have adequate screening procedures in place to ensure high standards when hiring employees.</li>
          <li>have ongoing employee training programme so that the members of the staff are adequately trained in Anti-Money Laundering standards (AML) and Combating the Financial of Terrorism (CFT) procedures.</li>
        </ol>

        <h3>XIII. Review of Policy</h3>
        <p>The policy shall be reviewed from time to time as and when required changes will be implemented as per the applicable rules, laws, acts and regulations.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: 'PMLA Policy' },
  pdfPath: { type: String, default: '' }
});

const emit = defineEmits(['close']);
const close = () => emit('close');
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.modal-content {
  width: 100%;
  max-width: 980px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.modal-header h3 { margin: 0; }
.modal-close { background: transparent; border: 0; cursor: pointer; color: #1f2937; font-weight: 700; }
.modal-body { padding: 16px 24px; overflow-y: auto; }
.doc { color: #1f2937; line-height: 1.6; font-size: 0.95rem; }
.doc h2 { font-size: 1.4rem; margin: 0 0 16px; text-align: center; }
.doc h3 { font-size: 1.1rem; margin: 22px 0 8px; color: #0e38d2; }
.doc p { margin: 6px 0; }
.doc ol, .doc ul { margin: 6px 0; padding-left: 24px; }
.doc li { margin: 4px 0; }
.doc a { color: #3b82f6; word-break: break-all; }
</style>
